import React from 'react';
import { Button } from 'govuk-react-jsx';
import { Link, useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { getInstallerDetails } from '../../features/application/applicationJourneySlice';
import {
  getCurrentLanguage,
  getCopyProviderCY,
  getCopyProviderEN,
} from '../../features/app/appSlice';
import { getUserDetails } from '../../features/dashboard/dashboardSlice';
import useTitle from '../../hooks/useTitle';

const InstallerConfirm = () => {
  const history = useHistory();

  const handleBtnClick = () => {
    history.push('/landlordApp/installation-address');
  };

  const installerDetailsRedux = useSelector(getInstallerDetails);
  const currentLanguage = useSelector(getCurrentLanguage);
  const copyProviderCY = useSelector(getCopyProviderCY);
  const copyProviderEN = useSelector(getCopyProviderEN);
  const currentUserData = useSelector(getUserDetails);
  const copyProvider =
    currentLanguage === 'en' ? copyProviderEN : copyProviderCY;
  useTitle(
    'landlordApp.InstallerConfirm.s7',
    'Confirm this is your installer - OZEV Electric Vehicle Chargepoint Grant - GOV.UK'
  );
  const pageModel = (
    <>
      <div className="govuk-form-group">
        <span className="govuk-caption-l">
          {currentUserData != null &&
            currentUserData.business_name != null &&
            currentUserData.business_name}
        </span>
        <h1 className="govuk-label--xl govuk-!-padding-bottom-7">
          {copyProvider.getCopy(
            'landlordApp.InstallerConfirm.s1',
            'Confirm this is your installer'
          )}
        </h1>
        <table className="govuk-body" role="presentation">
          <tr>
            <td>
              <h3 className="govuk-!-margin-bottom-0">
                {copyProvider.getCopy(
                  'landlordApp.InstallerConfirm.s2',
                  "Installer's OZEV number"
                )}
              </h3>
              <p className="govuk-body govuk-!-font-size-19 govuk-!-margin-bottom-0">
                {installerDetailsRedux &&
                  installerDetailsRedux?.installerDetails?.installer_number}
              </p>
            </td>
          </tr>
          <tr>
            <td>
              <h3 className="govuk-!-margin-bottom-0">
                {copyProvider.getCopy(
                  'landlordApp.InstallerConfirm.s3',
                  'Installer name'
                )}
              </h3>
              <p className="govuk-body govuk-!-font-size-19">
                {installerDetailsRedux &&
                  installerDetailsRedux?.installerDetails?.company_name}
              </p>
            </td>
          </tr>
        </table>
        <Link
          className="govuk-link govuk-body govuk-!-font-size-19"
          to="/landlordApp/installer-details"
        >
          {copyProvider.getCopy(
            'landlordApp.InstallerConfirm.s5',
            'This is not my installer'
          )}
        </Link>
      </div>
      <Button className="govuk-button" onClick={handleBtnClick}>
        {copyProvider.getCopy(
          'landlordApp.InstallerConfirm.s6',
          'Confirm and continue'
        )}
      </Button>
    </>
  );
  return pageModel;
};

export default InstallerConfirm;
